export default __webpack_public_path__ + "static/media/mtv-logo.2fa03e39.svg";